<div style="padding: 0;">
  <!-- Header verde -->
  <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 20px 24px; border-bottom: 2px solid #bbf7d0;">
    <div style="display: flex; align-items: center; gap: 10px;">
      <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">currency_exchange</mat-icon>
      <h1 style="font-size: 1.25rem; font-weight: 700; color: #1e5a3f; margin: 0;">Actualizar Tasas</h1>
    </div>
  </div>

  <div style="padding: 20px 24px;">
    <form *ngIf="formCuenta" [formGroup]="formCuenta">
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Tasa CLP</mat-label>
          <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">attach_money</mat-icon>
          <input type="number" matInput formControlName="tasaCLP" step="0.1"/>
        </mat-form-field>
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>% Comisión</mat-label>
          <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">percent</mat-icon>
          <input type="number" matInput formControlName="porcentajeComision" step="0.1"/>
        </mat-form-field>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Tasa Banesco</mat-label>
          <input type="number" matInput formControlName="tasaBanesco" step="0.01"/>
          <mat-hint style="font-size: 0.7rem;">
            Actual: {{ (this.calculoTasaMax(this.formCuenta.get("tasaCLP")?.value, this.formCuenta.get("tasaBanesco")?.value, 1)).toFixed(5) }}
          </mat-hint>
        </mat-form-field>
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Tasa Provincial</mat-label>
          <input type="number" matInput formControlName="tasaProvincial" step="0.01"/>
          <mat-hint style="font-size: 0.7rem;">
            Actual: {{ (this.calculoTasaMax(this.formCuenta.get("tasaCLP")?.value, this.formCuenta.get("tasaProvincial")?.value, 1)).toFixed(5) }}
          </mat-hint>
        </mat-form-field>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Tasa Mercantil</mat-label>
          <input type="number" matInput formControlName="tasaMercantil" step="0.01"/>
          <mat-hint style="font-size: 0.7rem;">
            Actual: {{ (this.calculoTasaMax(this.formCuenta.get("tasaCLP")?.value, this.formCuenta.get("tasaMercantil")?.value, 1)).toFixed(5) }}
          </mat-hint>
        </mat-form-field>
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Tasa Venezuela</mat-label>
          <input type="number" matInput formControlName="tasaVenezuela" step="0.01"/>
          <mat-hint style="font-size: 0.7rem;">
            Actual: {{ (this.calculoTasaMax(this.formCuenta.get("tasaCLP")?.value, this.formCuenta.get("tasaVenezuela")?.value, 1)).toFixed(5) }}
          </mat-hint>
        </mat-form-field>
      </div>

      <!-- Errores -->
      <div *ngIf="formCuenta.invalid || formCuenta.hasError('outOfRange')" style="margin-bottom: 12px;">
        <div *ngIf="formCuenta.get('tasaProvincial')?.hasError('outOfRange')"
          style="background: #fef2f2; color: #dc2626; padding: 6px 12px; border-radius: 8px; font-size: 0.75rem; font-weight: 600; margin-bottom: 4px;">
          Tasa Provincial no puede ser ±0.01 de {{ (this.calculoTasaMax(this.formCuenta.get("tasaCLP")?.value, this.data.tasaProvincial, 1)).toFixed(5) }}.
        </div>
        <div *ngIf="formCuenta.get('tasaBanesco')?.hasError('outOfRange')"
          style="background: #fef2f2; color: #dc2626; padding: 6px 12px; border-radius: 8px; font-size: 0.75rem; font-weight: 600; margin-bottom: 4px;">
          Tasa Banesco no puede ser ±0.01 de {{ (this.calculoTasaMax(this.formCuenta.get("tasaCLP")?.value, this.data.tasaBanesco, 1)).toFixed(5) }}.
        </div>
        <div *ngIf="formCuenta.get('tasaMercantil')?.hasError('outOfRange')"
          style="background: #fef2f2; color: #dc2626; padding: 6px 12px; border-radius: 8px; font-size: 0.75rem; font-weight: 600; margin-bottom: 4px;">
          Tasa Mercantil no puede ser ±0.01 de {{ (this.calculoTasaMax(this.formCuenta.get("tasaCLP")?.value, this.data.tasaMercantil, 1)).toFixed(5) }}.
        </div>
        <div *ngIf="formCuenta.get('tasaVenezuela')?.hasError('outOfRange')"
          style="background: #fef2f2; color: #dc2626; padding: 6px 12px; border-radius: 8px; font-size: 0.75rem; font-weight: 600; margin-bottom: 4px;">
          Tasa Venezuela no puede ser ±0.01 de {{ (this.calculoTasaMax(this.formCuenta.get("tasaCLP")?.value, this.data.tasaVenezuela, 1)).toFixed(5) }}.
        </div>
      </div>

      <!-- Botón -->
      <div class="flex justify-center">
        <button type="button" (click)="actualizarTasa()"
          [disabled]="formCuenta.invalid || formCuenta.hasError('outOfRange')"
          [style.opacity]="formCuenta.invalid || formCuenta.hasError('outOfRange') ? '0.5' : '1'"
          [style.cursor]="formCuenta.invalid || formCuenta.hasError('outOfRange') ? 'not-allowed' : 'pointer'"
          class="w-full sm:w-auto"
          style="display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 10px 40px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">save</mat-icon>
          Guardar
        </button>
      </div>
    </form>
  </div>
</div>
